export type OptionalSlot = 'cc' | 'bcc';

export const OPTIONAL_SLOTS: readonly OptionalSlot[] = ['cc', 'bcc'];

// A Cc or Bcc list shows once it holds an address or a problem, and after the user
// reveals it while the card can still be edited
export function showsSlot({
  entries,
  error,
  revealed,
  editable,
}: {
  entries: number;
  error: string | undefined;
  revealed: boolean;
  editable: boolean;
}): boolean {
  return entries > 0 || Boolean(error) || (editable && revealed);
}

// The lists a link can still reveal: bound by the card, not showing, and only while editable
export function hiddenSlots({
  bound,
  showing,
  editable,
}: {
  bound: readonly OptionalSlot[];
  showing: readonly OptionalSlot[];
  editable: boolean;
}): OptionalSlot[] {
  return editable ? bound.filter((slot) => !showing.includes(slot)) : [];
}
